import { useMemo } from 'react';
import { useAssetTimeRemaining } from '../userProgress';
import { useTrack } from './tracksQueries';
import { useAllLessons } from '../lessons';
export const useTrackContentIds = trackId => {
  const {
    track,
    trackLoading
  } = useTrack(trackId);
  const {
    allLessons,
    allLessonsLoading
  } = useAllLessons();
  const trackContentIdsLoading = trackLoading || allLessonsLoading;
  const trackContentIds = useMemo(() => {
    if (!track || !allLessons || trackContentIdsLoading) return [];
    return track.lessonIds.flatMap(lessonId => allLessons[lessonId] ? allLessons[lessonId].contentIds : []);
  }, [allLessons, track, trackContentIdsLoading]);
  return {
    trackContentIds,
    trackContentIdsLoading
  };
};
export const useTrackProgressTime = trackId => {
  const {
    track
  } = useTrack(trackId);
  const {
    trackContentIds,
    trackContentIdsLoading
  } = useTrackContentIds(trackId);
  const totalTime = track && track.duration || 0;
  const {
    remainingTime,
    allProgressLoading
  } = useAssetTimeRemaining({
    id: trackId,
    type: 'TRACK',
    contentIds: trackContentIds,
    totalTime
  });
  return {
    remainingTime,
    totalTime,
    trackProgressTimeLoading: allProgressLoading || trackContentIdsLoading
  };
};